import {
    skip_claustrophobia_if_already_known,
    skip_facial_hair_if_female
} from "./QuestionRouteLogic";

import { CommonQuestionTree } from "./CommonQuestionTree";
import { Node } from "./Node"
import { ForkRoute } from "./ForkRoute";


const build_tree = (prfx) => {

    let q_gender = `${prfx}gender`;
    let q_sleep_position = `${prfx}sleep_position`;
    let q_bed_partner =  `${prfx}bed_partner`;
    let q_glasses =  `${prfx}glasses`;
    let q_facial_hair =  `${prfx}facial_hair`;

    let q_skin_irritation =  `${prfx}skin_irritation`;
    let q_f_skin_irritation =  `${prfx}fm_skin_irritation`;

    let q_facial_creams = `${prfx}facial_creams`;
    let q_f_facial_creams = `${prfx}fm_facial_creams`;

    let q_claustrophbia = `${prfx}claustrophobia`;
    let q_f_claustrophbia = `${prfx}fm_claustrophobia`;

    let q_nasal_dryness = `${prfx}nasal_dryness`;
    let q_cl_nasal_dryness = `${prfx}cl_nasal_dryness`;
    let q_f_nasal_dryness = `${prfx}fm_nasal_dryness`;
    let q_f_cl_nasal_dryness = `${prfx}fm_cl_nasal_dryness`;

    let q_mobility = `${prfx}mobility`;
    let q_cl_mobility = `${prfx}cl_mobility`;
    let q_f_mobility = `${prfx}fm_mobility`;
    let q_f_cl_mobility = `${prfx}fm_cl_mobility`;

    let q_magnetic = `${prfx}magnetic`;
    let q_f_magnetic = `${prfx}fm_magnetic`;
    let q_cl_magnetic = `${prfx}cl_magnetic`;
    let q_f_cl_magnetic = `${prfx}fm_cl_magnetic`;

    let magneticNode = new Node(q_magnetic, "magnetic");
    let malePhobicMagneticNode = new Node(q_cl_magnetic, "magnetic");
    let femaleMagneticNode = new Node(q_f_magnetic, "magnetic");
    let femalePhobicMagneticNode = new Node(q_f_cl_magnetic, "magnetic");

    let mobilityNode = new Node(q_mobility, "mobility", [magneticNode]);
    let malePhobicMobilityNode = new Node(q_cl_mobility, "mobility", [malePhobicMagneticNode]);
    let femaleMobilityNode = new Node(q_f_mobility, "mobility", [femaleMagneticNode]);
    let femalePhobicMobilityNode = new Node(q_f_cl_mobility, "mobility", [femalePhobicMagneticNode]);

    let nasalDrynessNode = new Node(q_nasal_dryness, "nasal_dryness", [mobilityNode] );
    let malePhobicNasalDrynessNode = new Node(q_cl_nasal_dryness, "nasal_dryness", [malePhobicMobilityNode]);
    let femaleNasalDrynessNode = new Node(q_f_nasal_dryness, "nasal_dryness", [femaleMobilityNode]);
    let femalePhobicNasalDrynessNode = new Node(q_f_cl_nasal_dryness, "nasal_dryness", [femalePhobicMobilityNode]);

    let claustrophobiaNode = new Node(q_claustrophbia, "claustrophobia", [nasalDrynessNode] );
    let femaleClaustrophobiaNode = new Node(q_f_claustrophbia, "claustrophobia", [femaleNasalDrynessNode]) ;

    let skinCreamsNode = new Node(q_facial_creams, "facial_creams", [claustrophobiaNode, malePhobicNasalDrynessNode]);
    let femaleSkinCreamsNode = new Node(q_f_facial_creams, "facial_creams", [femaleClaustrophobiaNode, femalePhobicNasalDrynessNode]);

    let skinIrritationNode = new Node(q_skin_irritation, "skin_irritation", [skinCreamsNode]);
    let femaleSkinIrritationNode = new Node(q_f_skin_irritation, "skin_irritation", [femaleSkinCreamsNode]);

    let facialHairNode = new Node(q_facial_hair, "facial_hair", [skinIrritationNode]);
    let glassesNode = new Node(q_glasses, "glasses", [facialHairNode, femaleSkinIrritationNode] );
    let bedPartnerNode = new Node(q_bed_partner, "bed_partner", [glassesNode]);
    let sleepPositionNode = new Node(q_sleep_position, "sleep_position", [bedPartnerNode] );
    let genderNode = new Node(q_gender, "gender", [sleepPositionNode]);

    let dontAskFacialHairToWomenFork = new ForkRoute(glassesNode, facialHairNode, femaleSkinIrritationNode, skip_facial_hair_if_female, "NEXT_FEMALE")

    let claustrophobicGuyFork = new ForkRoute(skinCreamsNode, claustrophobiaNode, malePhobicNasalDrynessNode, skip_claustrophobia_if_already_known, "SKIP_CLAUSTROPHOBIA")
    let claustrophobicGalFork = new ForkRoute(femaleSkinCreamsNode, femaleClaustrophobiaNode, femalePhobicNasalDrynessNode, skip_claustrophobia_if_already_known, "SKIP_CLAUSTROPHOBIA")

    return new CommonQuestionTree(genderNode, [dontAskFacialHairToWomenFork, claustrophobicGuyFork, claustrophobicGalFork]);
}

export const build_common_questions = (prefix, begin_page, end_page, overrides = [] ) => {

    let tree = build_tree(prefix);

    for (let i = 0; i < overrides.length; i++) {
        tree.remove_question(overrides[i])
    }

    return tree.build_question_paths(begin_page, end_page);

}
